import { Button, Form, Popup } from 'devextreme-react';
import { GroupItem, Label, RequiredRule, SimpleItem } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userService } from '../../services/user.service';
import { dialogLogin } from '../../store/login/loginDialogReducer';

const PartialLogin = (props) => {

    const { user, loginDialog } = useSelector(store => store);

    const { open } = loginDialog;

    const [currentUser, setCurrentUser] = useState({ username: user.username, verificationCode: null });
    const [saving, setSaving] = useState(false);
    const [visible, setVisible] = useState(false);

    const refForm = useRef();
    const refForm2 = useRef();

    const dispatch = useDispatch();

    const closeDialog = () => {

        dispatch(dialogLogin({ open: false }));

    }

    const onHiding = () => {
        closeDialog();
    }

    const iniciaSesion = () => {

        let result = refForm.current.instance.validate();

        if (result.isValid) {

            userService.loginTwoFactor(currentUser).then(userResp => {

                if (userResp.twoFactorRequired) {

                    setVisible(true);
                    setSaving(false);

                } else {
                    auth(userResp);
                }

            }).catch(err => {
                setSaving(false);
                notify(err, "error");
            });
        }

    }

    const auth = () => {

        userService.updateSession();
        setCurrentUser({
            ...currentUser, password:'',verificationCode :null
        })
        closeDialog();
    } 

    const verificar = () => {

        let result = refForm2.current.instance.validate();

        if (result.isValid) {

            userService.login(currentUser).then(userResp => {

                auth(userResp);

            }).catch(err => {

                setVisible(false);
                setSaving(false);
                setCurrentUser({ ...currentUser, verificationCode: null });

                notify(err, "error");

            });
        }

    }

    return (
        <Popup
            width={290}
            height={250}
            title='Iniciar sesion'
            onHiding={onHiding}
            visible={open}
            showCloseButton={false}
            className="bg-fbfbfb"
        >
            <div>
                <div style={{ display: !visible ? 'block' : 'none' }}>
                    <Form formData={currentUser} ref={refForm}>
                        <GroupItem colCount={2}>
                            <SimpleItem dataField="username" colSpan={2}
                                editorOptions={{
                                    disabled: true
                                }} >

                            </SimpleItem>
                            <SimpleItem dataField="password" colSpan={2}
                                editorOptions={{
                                    stylingMode: "filled",
                                    mode: "password",
                                }} >
                                <RequiredRule message="Ingrese la contraseña" />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <Button
                        className="mt-10"
                        text={saving ? 'Iniciando...' : `Iniciar sesion`}
                        type="success"
                        icon='save'
                        disabled={saving}
                        onClick={iniciaSesion}
                    />
                </div>
                <div style={{ display: visible ? 'block' : 'none' }}>
                    <Form formData={currentUser} ref={refForm2}>
                        <GroupItem colCount={2}>
                            <SimpleItem dataField="verificationCode" colSpan={2}
                                editorOptions={{
                                    stylingMode: "filled",
                                    mode: "password",
                                }} >
                                <Label text="Código" />
                                <RequiredRule message="Ingrese codigo" />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <Button
                        className="mt-10"
                        text={saving ? 'verificando...' : `Verificar`}
                        type="success"
                        icon='save'
                        disabled={saving}
                        onClick={verificar}
                    />
                </div>
            </div>

        </Popup>
    );
}

export default PartialLogin;
